import { TENANT_PREFIX_PATH } from "configs/AppConfig";

export const API_BASE_URL = "";

// Config
export const ENTRY_ROUTE = "/auth/login";
export const TOKEN_PAYLOAD_KEY = "authorization";
export const PUBLIC_REQUEST_KEY = "public-request";
export const B2B_REQUEST_KEY = "b2b-request";

export const AUTH_TOKEN_KEY = "token";
export const USER_INFO_KEY = "userInfo";
export const USER_ACCESS_KEY = "user_access";

export const TENANT_KEY = "tenant";
export const X_TENANT_ID = "x-tenant-id";

export const ROLE_TYPE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  STUDENTS: "STUDENTS",
  PARTNER_ADMIN: "PARTNER_ADMIN",
};
export const ROLES = [
  { label: "Super Admin", val: "SUPER_ADMIN" },
  { label: "Student", val: "STUDENTS" },
  { label: "Partner Admin", val: "PARTNER_ADMIN" },
];

export const SYSTEM_ROLES = [
  { label: "Super Admin", value: "SUPER_ADMIN" },
  { label: "Student", value: "STUDENTS" },
  { label: "Partner Admin", value: "PARTNER_ADMIN" },
];

export const TENANTS_ROLES = [];

export const DEFAULT_PAGE_SIZE = 10;

// Sentinel used by affiliate ID filter dropdowns for the "no affiliate"
// option. Select components can't carry an actual `null` option value
// through antd's controlled Form state cleanly, so the UI uses this string
// and translates it to a real JSON `null` right before it's sent as
// `where.affiliateId` to the API.
export const NO_AFFILIATE_ID_VALUE = "__NO_AFFILIATE__";

export const DEFAULT_AFFILIATE_ID_OPTIONS = Array.from(
  new Set([
    "affiliate_id",
    "email",
    "Google_ads",
    "anupamtest",
    "scholarshipprograms",
    "ig",
    "meta",
    "rxmg",
    "studentscholarships",
    "www.nerdydata.com",
    "mymozaic",
    "unigo4lennyai",
    "chatgpt.com",
    "money",
    "nichecom",
    "boldorg",
    "golfers-university",
    "scholarship",
    "sallie",
    "fastweb",
    "cedar-education",
    "bing",
    "th",
    "google",
    "an",
    "anupamsingh",
    "himanshu-deshwal",
    "copilot.com",
    "fb",
    "Email",
    "share",
    "brian-geiger",
  ]),
).sort();

export const ADD = "ADD";
export const EDIT = "EDIT";

export const UPLOAD_DRAG_PROPS = {
  name: "file",
  multiple: true,
  listType: "picture-card",
  showUploadList: false,
  action: null,
};

export const API_PATH = {
  SCHOLARSHIP_MONTHLY_STATS: "/scholarships/monthly-summary",
  SCHOLARSHIP_MONTHLY_STATS_REPORT: "/scholarship-tracking/report",
  SCHOLARSHIP_MONTHLY_STATS_TRENDS: "/scholarship-tracking/trends",
  CALCULATE_SCHOLARSHIP_DATE: "/scholarship-tracking/calculate",

  SUPER_ADMIN_LOGIN: "/users/auth/login",
  SUPER_ADMIN_LOGOUT: "/auth/logout",
  SUPER_ADMIN_PASSWORD_LINK: "/auth/reset-password-link",
  SUPER_ADMIN_PASSWORD: "/auth/reset-password",

  GET_ESSAY: "/users/get-essay",

  //users
  USERS_LIST: "/register-applicants",
  USERS_LIST: "/register-applicants",
  USERS_COUNT: "/register-applicants/count",
  USERS_REGISTER: "/register-applicants",
  USERS_UPDATE: (userId) => `/register-applicants/${userId}`,
  USERS_DETAIL: (userId) => `/register-applicants/${userId}`,
  USERS_DELETE: (userId) => `/register-applicants/${userId}`,
  USERS_FORM_FIELDS: "register-applicants/form-fields",
  USERS_ADMIN_RESET_PASSWORD: (userId) => `/users/admin/${userId}/password`,
  ADMIN_USERS_LIST: "/users/admin",
  ADMIN_USERS_CREATE: "/users/admin",
  ADMIN_USERS_STATUS: (userId) => `/users/admin/${userId}/status`,

  //orders
  ORDERS_LIST: "/user-payments",
  ORDERS_COUNT: "/user-payments/count",
  ORDERS_EXPORT_EXCEL: "user-payments/export/excel",
  ORDERS_SUMMARY: "/user-payments/summary",
  ORDERS_STRIPE_INVOICE_FAILURE_REASON: (invoiceId) =>
    `/user-payments/stripe/invoice/${invoiceId}/failure-reason`,
  ORDERS_STRIPE_PAYMENT_INTENT_FAILURE_REASON: (paymentIntentId) =>
    `/user-payments/stripe/payment-intent/${paymentIntentId}/failure-reason`,

  // Business user
  BUSINESS_USERS_LIST: "users/business-users",
  BUSINESS_USERS_LIST_FILTER: "/users",
  BUSINESS_USERS_COUNT: "/users/count",
  BUSINESS_USER_REGISTER: "users/auth/register",
  BUSINESS_USERS_EDIT: (userId) => `users/businessUser/${userId}`,
  BUSINESS_USER_RESET_PASSWORD: "/users/auth/reset-password",

  // register applicants
  APPLICANTS_USERS_LIST: "/register-applicants",
  // USERS_COUNT: "/users/counts",
  // USERS_REGISTER: "/users",
  // USERS_UPDATE: (userId) => `/users/${userId}`,
  // USERS_DETAIL: (userId) => `/users/${userId}`,
  // USERS_DELETE: (userId) => `/users/${userId}`,

  //scholarships
  SCHOLARSHIP_LIST: "/scholarships",
  SCHOLARSHIPS_COUNT: "/scholarships/count",
  SCHOLARSHIP_FIELDS: (scholarshipId) => `/scholarship/${scholarshipId}/fields`,
  SCHOLARSHIP_REQUIREMENTS: (scholarshipId) =>
    `/scholarship/${scholarshipId}/requirement`,

  SCHOLARSHIPS_DETAIL: (scholarshipId) => `/scholarships/${scholarshipId}`,
  SCHOLARSHIPS_DELETE: (scholarshipId) => `/scholarships/${scholarshipId}`,
  SCHOLARSHIPS_APPLICANTS: (scholarshipId) =>
    `/scholarships/${scholarshipId}/applicants`,
  SCHOLARSHIPS_FIELDS_LIST: `/fields`,
  SCHOLARSHIPS_FIELDS_ONLY: `/fields?where={"type":"field"}`,
  SCHOLARSHIPS_REQUIREMENTS_ONLY: `/fields?where={"type":"requirement"}`,

  SCHOLARSHIP_LIST_EMAIL: (email) =>
    `/scholarships/{scholarshipId}/applicants/getuserbyemail?email=${email}`,

  // Sponsored Scholarships
  SPONSORED_SCHOLARSHIPS_LIST: "/scholarships/sponsored",
  SCHOLARSHIP_SPONSOR: (scholarshipId) =>
    `/scholarships/${scholarshipId}/sponsor`,
  SCHOLARSHIP_SPONSORSHIP_TYPE: (scholarshipId) =>
    `/scholarships/${scholarshipId}/sponsorship-type`,
  SCHOLARSHIP_STATUS: (scholarshipId) =>
    `/scholarships/${scholarshipId}/status`,

  // Navy Leads
  NAVY_LEADS_LIST: "/register-applicants/navy-applicants",
  NAVY_LEADS_COUNT: "/register-applicants/navy-applicants/count",
  NAVY_LEADS_DETAIL: (leadId) =>
    `/register-applicants/navy-applicants/${leadId}`,

  // College Recon Leads
  COLLEGE_RECON_LEADS_LIST: "/register-applicants/college-reccon-leads",
  COLLEGE_RECON_LEADS_COUNT: "/register-applicants/college-reccon-leads/count",
  COLLEGE_RECON_LEADS_DETAIL: (leadId) =>
    `/register-applicants/college-reccon-leads/${leadId}`,

  // ArcaMax (Cobra) Leads
  ARCAMAX_LEADS_STATS: "/arcamax/stats",
  ARCAMAX_LEADS_LIST: "/arcamax/subscriptions",
  ARCAMAX_RETRY_BY_EMAIL: "/arcamax/process-by-email",

  // Upload
  UPLOAD_PERMANENT: "/common/upload-permanent",

  // Loans
  LOANS_ADMIN_LIST: "/loans/admin",
  LOANS_CREATE: "/loans",
  LOANS_UPDATE: (id) => `/loans/${id}`,
  LOANS_TOGGLE: (id) => `/loans/${id}/toggle`,
  LOANS_DELETE: (id) => `/loans/${id}`,

  // Partners
  PARTNERS_LIST: "/admin/partners",
  PARTNERS_CREATE: "/admin/partners",
  PARTNERS_UPDATE: (partnerSlug) => `/admin/partners/${partnerSlug}`,
  PARTNERS_TOGGLE: (partnerSlug) => `/admin/partners/${partnerSlug}/toggle`,
  PARTNERS_REVEAL_KEY: (partnerSlug) => `/admin/partners/${partnerSlug}/reveal-key`,
  PARTNERS_DELETE: (partnerSlug) => `/admin/partners/${partnerSlug}`,
  PARTNERS_SET_LINK: (partnerSlug) => `/admin/partners/${partnerSlug}/link`,
  PARTNERS_REVENUE_ALL: "/admin/partners/revenue",
  PARTNERS_REVENUE_EVENTS: "/admin/partners/revenue/events",
  PARTNERS_REVENUE_CAMPAIGNS: "/admin/partners/revenue/campaigns",
  PARTNERS_ADMIN_USERS_CREATE: (partnerSlug) => `/admin/partners/${partnerSlug}/admin-users`,
  PARTNERS_POSTBACK_LOGS: (partnerSlug) => `/admin/partners/${partnerSlug}/postback-logs`,
  PARTNERS_ATTRIBUTIONS: (partnerSlug) => `/admin/partners/${partnerSlug}/attributions`,
  PARTNERS_FUNNEL: (partnerSlug) => `/admin/partners/${partnerSlug}/funnel`,
  PARTNERS_BACKFILL_AD_IDS: "/admin/partners/backfill-ad-ids",

  // Direct offers (ads that link straight to a partner page; partner posts conversions back)
  OFFERS_LIST: "/admin/offers",
  OFFERS_CREATE: "/admin/offers",
  OFFERS_UPDATE: (id) => `/admin/offers/${id}`,
  OFFERS_SUMMARY: "/admin/offers/summary",
  OFFERS_CONVERSIONS: "/admin/offers/conversions",
  OFFERS_CONVERSION_DETAIL: (id) => `/admin/offers/conversions/${id}`,
  OFFERS_CONVERSION_SNAPSHOT: (id) => `/admin/offers/conversions/${id}/snapshot`,
  OFFERS_CONVERSION_RESEND_META: (id) => `/admin/offers/conversions/${id}/resend-meta`,

  // Account Deletion Logs
  ACCOUNT_DELETION_LOGS: "/admin/account-deletion-logs",
  ACCOUNT_DELETION_LOG_DETAIL: (id) => `/admin/account-deletion-logs/${id}`,
};
